import React from 'react';
import { 
  Box, 
  TextField, 
  Button, 
  Menu, 
  Typography, 
  FormGroup, 
  FormControlLabel, 
  Checkbox,
  InputAdornment,
  IconButton,
  Popover
} from '@mui/material';
import { 
  Search as SearchIcon,
  FilterList as FilterIcon 
} from '@mui/icons-material';

const SalesFilters = ({
  searchQuery,
  onSearchChange,
  filterAnchorEl,
  onFilterClick,
  onFilterClose,
  filters,
  onFilterChange
}) => {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', my: 2 }}>
      <TextField
        variant="outlined"
        size="small"
        placeholder="Search for invoices..."
        value={searchQuery}
        onChange={onSearchChange}
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon fontSize="small" />
            </InputAdornment>
          ),
        }}
        sx={{ 
          width: '100%',
          maxWidth: 500,
          height: 28,
          '& .MuiOutlinedInput-root': {
            borderRadius: '2px',
            height: 28,
          },
          '& .MuiInputBase-input': {
            py: 0.5,
          }
        }}
      />
      <Button
        variant="outlined"
        startIcon={<FilterIcon />}
        size="small"
        onClick={onFilterClick}
        sx={{ 
          borderRadius: '2px',
          textTransform: 'none',
          py: 0.25,
          px: 1,
          height: 28,
          ml: 1,
        }}
      >
        Filters
      </Button>
      <Menu
        anchorEl={filterAnchorEl}
        open={Boolean(filterAnchorEl)}
        onClose={onFilterClose}
        PaperProps={{
          sx: {
            width: 200,
            p: 1,
          },
        }}
      >
        <Typography variant="subtitle2" sx={{ px: 1, py: 0.5 }}>Payment Status</Typography>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.paymentStatus.paid}
                  onChange={(e) => onFilterChange('paymentStatus', { paid: e.target.checked })}
                size="small"
                />
              }
              label="Paid"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.paymentStatus.pending}
                  onChange={(e) => onFilterChange('paymentStatus', { pending: e.target.checked })}
                size="small"
                />
              }
              label="Pending"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.paymentStatus.overdue}
                  onChange={(e) => onFilterChange('paymentStatus', { overdue: e.target.checked })}
                size="small"
                />
              }
              label="Overdue"
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={filters.paymentStatus.draft}
                  onChange={(e) => onFilterChange('paymentStatus', { draft: e.target.checked })}
                size="small"
                />
              }
              label="Draft"
            />
          </FormGroup>
      </Menu>
    </Box>
  );
};

export default React.memo(SalesFilters); 